import { z } from "zod";

export const rotationParametersSchema = z.object({
	rotateRight: z.string(),
	isFlip: z.boolean(),
});
export type RotationParameters = z.infer<typeof rotationParametersSchema>;
